module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceApply"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      请选择发票类型\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-val"
  }, [_c('div', {
    staticClass: "radio-but",
    attrs: {
      "ac": _vm.form.invoices_type == 1
    },
    on: {
      "click": function($event) {
        _vm.form.invoices_type = 1
      }
    }
  }, [_vm._v("\n            电子发票\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "radio-but",
    attrs: {
      "ac": _vm.form.invoices_type == 2
    },
    on: {
      "click": function($event) {
        _vm.form.invoices_type = 2
      }
    }
  }, [_vm._v("\n            纸质发票\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row2"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      发票详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          抬头类型\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.form.title_type = 1
      }
    }
  }, [_c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.title_type == 1
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })]), _vm._v("\n            企业抬头\n          ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "1rem"
    },
    on: {
      "click": function($event) {
        _vm.form.title_type = 2
      }
    }
  }, [_c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.title_type == 2
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })]), _vm._v("\n            个人/非企业单位\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          发票抬头\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    attrs: {
      "placeholder": "请输入公司全称"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          纳税人识别号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.taxpayer_number),
      expression: "form.taxpayer_number"
    }],
    attrs: {
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.form.taxpayer_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "taxpayer_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          发票内容\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoices_memo),
      expression: "form.invoices_memo"
    }],
    attrs: {
      "placeholder": "请输入发票内容"
    },
    domProps: {
      "value": (_vm.form.invoices_memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invoices_memo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          开票金额\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoices_amount),
      expression: "form.invoices_amount"
    }],
    attrs: {
      "placeholder": "可开票额度998.0元"
    },
    domProps: {
      "value": (_vm.form.invoices_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invoices_amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          更多信息\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.more_info),
      expression: "form.more_info"
    }],
    attrs: {
      "placeholder": "请输入备注，开户行信息等"
    },
    domProps: {
      "value": (_vm.form.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "more_info", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row3"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      收件信息\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [(_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          收件人\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.addressee),
      expression: "form.addressee"
    }],
    attrs: {
      "placeholder": "请输入收件人"
    },
    domProps: {
      "value": (_vm.form.addressee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "addressee", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          联系电话\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telephone),
      expression: "form.telephone"
    }],
    attrs: {
      "placeholder": "请输入联系电话"
    },
    domProps: {
      "value": (_vm.form.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "telephone", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          所在地区\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.area),
      expression: "form.area"
    }],
    attrs: {
      "placeholder": "请输入所在地区"
    },
    domProps: {
      "value": (_vm.form.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "area", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          详细地址\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    attrs: {
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 1) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          电子邮件\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "placeholder": "请输入电子邮件"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "row row5"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      支付方式\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 1
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国8元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 1
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 2
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国8元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 2
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 3
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国10元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 3
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "but"
  }, [_vm._v("申请开票")]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-weixinzhifu",
    staticStyle: {
      "color": "#51b234"
    }
  }), _vm._v("微信支付\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-yuezhifu",
    staticStyle: {
      "color": "#4394d5"
    }
  }), _vm._v("余额支付\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-huodaofukuan",
    staticStyle: {
      "color": "#4394d5"
    }
  }), _vm._v("货到付款\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660647ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/invoice/invoiceApply.vue
// module id = 540
// module chunks = 0